import { RecommendationsTrackingDataDto } from "./RecommendationsTrackingDataDto";

export default abstract class RecoTracking {
  abstract trackRecoImpression(
    data: RecommendationsTrackingDataDto,
    visiblePositions: Array<string>,
  ): void;

  abstract trackRecoClick(
    data: RecommendationsTrackingDataDto,
    position?: number,
  ): void;
}
